import {
    Button,
    DialogActions,
    DialogContent,
    Stack,
    TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DialogHeader from "../../../components/Dialog/DialogHeader";
import UserDialog from "../../../components/Dialog/UserDialog";
import {WeaponTrait} from "../../../model/Dto/Dict/Trait";

interface TraitDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (data: { name: string; description: string }) => Promise<boolean>;
    initialData?: WeaponTrait | null;
    title: string;
}

export default function TraitDialog({
                                        open,
                                        onClose,
                                        onSave,
                                        initialData,
                                        title,
                                    }: TraitDialogProps) {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (initialData) {
            setName(initialData.name);
            setDescription(initialData.description);
        } else {
            setName("");
            setDescription("");
        }
    }, [initialData, open]);

    const handleSave = async () => {
        setLoading(true);
        const success = await onSave({ name: name.trim(), description: description.trim() });
        setLoading(false);

        if (success) {
            onClose();
        }
    };

    return (
        <UserDialog handleClose={onClose} open={open} maxWidth="md">
            <DialogHeader loading={loading} title={title} />
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 2 }}>
                    <TextField
                        autoFocus
                        label="Название"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        disabled={loading}
                    />
                    <TextField
                        label="Описание"
                        fullWidth
                        multiline
                        minRows={4}
                        maxRows={16}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        disabled={loading}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Отмена
                </Button>
                <Button onClick={handleSave} variant="contained" color="primary" disabled={loading}>
                    {loading ? "Сохранение..." : "Сохранить"}
                </Button>
            </DialogActions>
        </UserDialog>
    );
}